import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import bookingApiController from "services/booking.service";
import HandleError from "../HandleError";
import HandleResponse from "../HandleResponse";

export const getBookingSummaryApi = createAsyncThunk(
  "bookingSummary/get",
  async (formValues, thunkAPI) => {
    try {
      const responseData = await bookingApiController
        .getBookingSummary(formValues)
        .then((response) => HandleResponse(thunkAPI, response, "bookingSummary"))
        .catch((error) => HandleError(thunkAPI, error, "bookingSummary"));
      return responseData;
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

const initialState = {
  bookingSummaryData: null,
  isLoading: false,
  error: null,
  status: "idle",
};

const bookingSummarySlice = createSlice({
  name: "bookingSummary",
  initialState,
  reducers: {
    resetBookingSummary: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getBookingSummaryApi.pending, (state) => {
        state.isLoading = true;
        state.status = "loading";
        state.error = null;
      })
      .addCase(getBookingSummaryApi.fulfilled, (state, action) => {
        state.isLoading = false;
        state.status = "succeeded";
        state.bookingSummaryData = action.payload;
      })
      .addCase(getBookingSummaryApi.rejected, (state, action) => {
        state.isLoading = false;
        state.status = "failed";
        state.error = action.payload;
      });
  },
});

export const { resetBookingSummary } = bookingSummarySlice.actions;
export default bookingSummarySlice.reducer; 